import React from "react";
import { Box, Flex, Text, Circle } from "@chakra-ui/react";
import Translate from "../../components/LanguageTranslation/Translate";
// Theming
const STEP_COLORS = {
  active: "#36b23f", // green
  inactive: "#333", // dark
};

const steps = [
  {
    title: "Step 1",
    desc: "Select your preferred offset program",
  },
  {
    title: "Step 2",
    desc: "Calculate your carbon footprint",
  },
  {
    title: "Step 3",
    desc: "Receive your unique 'Proof of Impact'",
  },
];

// Pass activeStep = 0 for Step 1, 1 for Step 2, 2 for Step 3
// Previous and current steps will be green, future steps will be dark
const StepsProgress = ({ activeStep = 0, onStepClick }) => (
  <Flex
    w="100%"
    maxW={{base: "400px", md: "650px", lg: "600px", xl: "800px"}}
    mx="auto"
    align="center"
    justify="center"
    py={8}
    px={{ base: 4, md: 12 }}
    bg="transparent"
  >
    {steps.map((step, i) => (
      <Flex
        key={i}
        flexDir="column"
        align="center"
        flex="1"
        cursor={i <= activeStep ? "pointer" : "default"}
        onClick={() => onStepClick && i <= activeStep && onStepClick(i)}
        _hover={i <= activeStep ? { opacity: 0.8 } : {}}
        transition="opacity 0.2s"
      >
        {/* Circles and connecting line */}
        <Flex align="center" w="100%">
          {/* Left line */}
          {i !== 0 && (
            <Box
              h="4px"
              flex="1"
              bg={i <= activeStep ? STEP_COLORS.active : STEP_COLORS.inactive}
            />
          )}

          {/* Step Circle */}
          <Circle
            size="24px"
            bg={i <= activeStep ? STEP_COLORS.active : STEP_COLORS.inactive}
            border={i <= activeStep ? "2px solid #36b23f" : "2px solid #333"}
            zIndex={1}
          />

          {/* Right line */}
          {i !== steps.length - 1 && (
            <Box
              h="4px"
              flex="1"
              bg={i < activeStep ? STEP_COLORS.active : STEP_COLORS.inactive}
            />
          )}
        </Flex>

        {/* Step Text */}
        <Text mt={3} fontWeight="bold" fontSize={{base: "sm", md: "md"}} textAlign="center">
          {step.title}
        </Text>
        <Text
          fontSize={{base: "xs", md: "sm"}}
          color="gray.600"
          // maxW="100px"
          textAlign="center"
          mt={1}
        >
           <Translate text={step.desc} />
        </Text>
      </Flex>
    ))}
  </Flex>
);

export default StepsProgress;
